// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SectionHeader-module__font-s-10___kZE5m {
  font-size: 10px !important;
}

.SectionHeader-module__font-s-12___mLpif {
  font-size: 12px !important;
}

.SectionHeader-module__font-s-13___eIgak {
  font-size: 13px !important;
}

.SectionHeader-module__font-s-14___SExwR {
  font-size: 14px !important;
}

.SectionHeader-module__font-s-15___YU_Gq {
  font-size: 15px !important;
}

.SectionHeader-module__font-s-16___cCaVK {
  font-size: 16px !important;
}

.SectionHeader-module__font-s-18___hSOUE {
  font-size: 18px !important;
}

.SectionHeader-module__font-s-20___G72zv {
  font-size: 20px !important;
}

.SectionHeader-module__font-s-22___VbWuu {
  font-size: 22px !important;
}

.SectionHeader-module__font-s-28___np7uu {
  font-size: 28px !important;
}

.SectionHeader-module__font-w-400___yW0tZ {
  font-weight: 400 !important;
}

.SectionHeader-module__font-w-500___XAfHb {
  font-weight: 500 !important;
}

.SectionHeader-module__font-w-600___LvfiO {
  font-weight: 600 !important;
}

.SectionHeader-module__font-w-700___Z9eSN {
  font-weight: 700 !important;
}

.SectionHeader-module__p-5___lzOxM {
  padding: 5px !important;
}

.SectionHeader-module__p-12___jkQOc {
  padding: 12px !important;
}

.SectionHeader-module__p-16___mgRAR {
  padding: 16px !important;
}

.SectionHeader-module__p-30___MyJKh {
  padding: 30px !important;
}

.SectionHeader-module__p-b-0___nSa5H {
  padding-bottom: 0 !important;
}

.SectionHeader-module__p-b-5___i66Vg {
  padding-bottom: 5px !important;
}

.SectionHeader-module__p-b-10___QNtID {
  padding-bottom: 10px !important;
}

.SectionHeader-module__p-b-12___HN3wu {
  padding-bottom: 12px !important;
}

.SectionHeader-module__p-b-16___v9nla {
  padding-bottom: 16px !important;
}

.SectionHeader-module__p-b-18___BF01l {
  padding-bottom: 18px !important;
}

.SectionHeader-module__p-b-20___JxSyq {
  padding-bottom: 20px !important;
}

.SectionHeader-module__p-b-25___dq4sk {
  padding-bottom: 25px !important;
}

.SectionHeader-module__p-b-30___JvDSM {
  padding-bottom: 30px !important;
}

.SectionHeader-module__p-b-50___AQ9F4 {
  padding-bottom: 50px !important;
}

.SectionHeader-module__p-t-0___Bt1rd {
  padding-top: 0 !important;
}

.SectionHeader-module__p-t-12___MrQkk {
  padding-top: 12px !important;
}

.SectionHeader-module__p-t-16___bXUCd {
  padding-top: 16px !important;
}

.SectionHeader-module__p-t-18___WGm_a {
  padding-top: 18px !important;
}

.SectionHeader-module__p-t-20___mfjkH {
  padding-top: 20px !important;
}

.SectionHeader-module__p-t-30___jovxq {
  padding-top: 30px !important;
}

.SectionHeader-module__p-t-40___T5AEu {
  padding-top: 40px !important;
}

.SectionHeader-module__p-t-50___enws_ {
  padding-top: 50px !important;
}

.SectionHeader-module__p-l-20___Gn_YJ {
  padding-left: 20px !important;
}

.SectionHeader-module__p-l-30___ZWSqr {
  padding-left: 30px !important;
}

.SectionHeader-module__p-l-40___BViSy {
  padding-left: 40px !important;
}

.SectionHeader-module__p-r-16___LytOW {
  padding-right: 16px !important;
}

.SectionHeader-module__p-r-20___ZDiHP {
  padding-right: 20px !important;
}

.SectionHeader-module__p-r-30___CsjS6 {
  padding-right: 30px !important;
}

.SectionHeader-module__p-r-50___wZXSp {
  padding-right: 50px !important;
}

.SectionHeader-module__p-r-60___yJaQn {
  padding-right: 60px !important;
}

.SectionHeader-module__m-b-1___qpkNi {
  margin-bottom: 1px !important;
}

.SectionHeader-module__m-b-2___C5gi6 {
  margin-bottom: 2px !important;
}

.SectionHeader-module__m-b-6___jUumo {
  margin-bottom: 6px !important;
}

.SectionHeader-module__m-b-8___SuMvE {
  margin-bottom: 8px !important;
}

.SectionHeader-module__m-b-10___n99JS {
  margin-bottom: 10px !important;
}

.SectionHeader-module__m-b-14___sN5Vc {
  margin-bottom: 14px !important;
}

.SectionHeader-module__m-b-16___OGouY {
  margin-bottom: 16px !important;
}

.SectionHeader-module__m-b-20___K1wKn {
  margin-bottom: 20px !important;
}

.SectionHeader-module__m-b-22___zQkjn {
  margin-bottom: 22px !important;
}

.SectionHeader-module__m-b-24___bWLHJ {
  margin-bottom: 24px !important;
}

.SectionHeader-module__m-b-30___Z3Txu {
  margin-bottom: 30px !important;
}

.SectionHeader-module__m-b-32___HXur9 {
  margin-bottom: 32px !important;
}

.SectionHeader-module__m-b-40____BBu4 {
  margin-bottom: 40px !important;
}

.SectionHeader-module__m-t-2___WKNf2 {
  margin-top: 2px !important;
}

.SectionHeader-module__m-t-3___HhVzc {
  margin-top: 3px !important;
}

.SectionHeader-module__m-t-4___VTf_b {
  margin-top: 4px !important;
}

.SectionHeader-module__m-t-5___BjoF5 {
  margin-top: 5px !important;
}

.SectionHeader-module__m-t-8___z6Ifu {
  margin-top: 8px !important;
}

.SectionHeader-module__m-t-10___Onnu_ {
  margin-top: 10px !important;
}

.SectionHeader-module__m-t-15___dkHhZ {
  margin-top: 15px !important;
}

.SectionHeader-module__m-t-16___g7wCt {
  margin-top: 16px !important;
}

.SectionHeader-module__m-t-20___Dxsjp {
  margin-top: 20px !important;
}

.SectionHeader-module__m-t-22___XSF5h {
  margin-top: 22px !important;
}

.SectionHeader-module__m-t-30___BJVVN {
  margin-top: 30px !important;
}

.SectionHeader-module__m-t-32___HZ2kD {
  margin-top: 32px !important;
}

.SectionHeader-module__m-l-auto____J9iY {
  margin-left: auto !important;
}

.SectionHeader-module__m-l-4___qZC2R {
  margin-left: 4px !important;
}

.SectionHeader-module__m-l-5___a4vWW {
  margin-left: 5px !important;
}

.SectionHeader-module__m-l-6___IMPI4 {
  margin-left: 6px !important;
}

.SectionHeader-module__m-l-8___SoRu6 {
  margin-left: 8px !important;
}

.SectionHeader-module__m-l-10___dmRmh {
  margin-left: 10px !important;
}

.SectionHeader-module__m-l-16___N56c8 {
  margin-left: 16px !important;
}

.SectionHeader-module__m-l-20___wdYnB {
  margin-left: 20px !important;
}

.SectionHeader-module__m-l-24___Mohbp {
  margin-left: 24px !important;
}

.SectionHeader-module__m-l-30___PK_cR {
  margin-left: 30px !important;
}

.SectionHeader-module__m-l-35___opm4j {
  margin-left: 35px !important;
}

.SectionHeader-module__m-l-40___vx709 {
  margin-left: 40px !important;
}

.SectionHeader-module__m-r-8___yYB4w {
  margin-right: 8px !important;
}

.SectionHeader-module__m-r-10___NVbBi {
  margin-right: 10px !important;
}

.SectionHeader-module__m-r-16___pL9X9 {
  margin-right: 16px !important;
}

.SectionHeader-module__m-r-20___BbwWv {
  margin-right: 20px !important;
}

.SectionHeader-module__m-r-24___tPSsD {
  margin-right: 24px !important;
}

.SectionHeader-module__m-r-30___pdlZd {
  margin-right: 30px !important;
}

.SectionHeader-module__m-r-40___OrXWY {
  margin-right: 40px !important;
}

.SectionHeader-module__border-r-3___dMglH {
  border-radius: 3px !important;
}

.SectionHeader-module__border-r-4___botUG {
  border-radius: 4px !important;
}

.SectionHeader-module__border-r-6___EbIyE {
  border-radius: 6px !important;
}

.SectionHeader-module__border-r-10___cCYTu {
  border-radius: 10px !important;
}

.SectionHeader-module__border-r-12___PXS8j {
  border-radius: 12px !important;
}

.SectionHeader-module__border-r-16___mJFXw {
  border-radius: 16px !important;
}

.SectionHeader-module__border-r-50___z3o1L {
  border-radius: 50% !important;
}

.SectionHeader-module__primary-border___WRCUa {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionHeader-module__primary-border-b___KDeS_ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionHeader-module__primary-border-t___i2Ur0 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionHeader-module__primary-border-l___u4g_t {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionHeader-module__primary-border-r___mKjc1 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionHeader-module__secondary-border___rnNWO {
  border: 1px solid #637768;
}

.SectionHeader-module__secondary-border-b___qPjp9 {
  border-bottom: 1px solid #637768;
}

.SectionHeader-module__secondary-border-t___h6NX9 {
  border-top: 1px solid #637768;
}

.SectionHeader-module__secondary-border-l___ytdpE {
  border-left: 1px solid #637768;
}

.SectionHeader-module__secondary-border-r___qi3ay {
  border-right: 1px solid #637768;
}

.SectionHeader-module__gap-0___WD373 {
  gap: 0 !important;
}

.SectionHeader-module__gap-2___DqxE2 {
  gap: 2px !important;
}

.SectionHeader-module__gap-4___pclIg {
  gap: 4px !important;
}

.SectionHeader-module__gap-5___S70Ks {
  gap: 5px !important;
}

.SectionHeader-module__gap-6___lCPEr {
  gap: 6px !important;
}

.SectionHeader-module__gap-8___FPChN {
  gap: 8px !important;
}

.SectionHeader-module__gap-10___dU4Eo {
  gap: 10px !important;
}

.SectionHeader-module__gap-12___VFsPx {
  gap: 12px !important;
}

.SectionHeader-module__gap-14___G88vX {
  gap: 14px !important;
}

.SectionHeader-module__gap-16___X8K6t {
  gap: 16px !important;
}

.SectionHeader-module__gap-18___CbHhn {
  gap: 18px !important;
}

.SectionHeader-module__gap-20___u9GzI {
  gap: 20px !important;
}

.SectionHeader-module__gap-24___EkZ2e {
  gap: 24px !important;
}

.SectionHeader-module__gap-26___MBJTa {
  gap: 26px !important;
}

.SectionHeader-module__gap-30___CAbq6 {
  gap: 30px !important;
}

.SectionHeader-module__gap-32___Qbpyc {
  gap: 32px !important;
}

.SectionHeader-module__gap-40___fvjzc {
  gap: 40px !important;
}

.SectionHeader-module__gap-50___sFbw0 {
  gap: 50px !important;
}

.SectionHeader-module__flex-1___kvOhA {
  flex: 1;
}

.SectionHeader-module__flex-none___dUuds {
  flex: none !important;
}

.SectionHeader-module__flex-column___HSCnj {
  display: flex;
  flex-direction: column !important;
}

.SectionHeader-module__flex-row___MlxKi {
  display: flex;
  flex-direction: row !important;
}

.SectionHeader-module__vertically-centered___StE7V {
  display: flex;
  align-items: center !important;
}

.SectionHeader-module__horizontally-centered___cHnfN {
  display: flex;
  justify-content: center !important;
}

.SectionHeader-module__horizontally-end___nweBH {
  display: flex;
  justify-content: end !important;
}

.SectionHeader-module__vertically-start___mEi4e {
  display: flex;
  align-items: start !important;
}

.SectionHeader-module__space-between___OUdGz {
  display: flex;
  justify-content: space-between !important;
}

.SectionHeader-module__flex-wrap___ZbrvT {
  flex-wrap: wrap !important;
}

.SectionHeader-module__height-100___NYRDc {
  height: 100%;
}

.SectionHeader-module__width-50___mhTky {
  width: 50% !important;
}

.SectionHeader-module__width-100___RyLT2 {
  width: 100%;
}

.SectionHeader-module__cursor-pointer___pruaL {
  cursor: pointer;
}

.SectionHeader-module__cursor-not-allowed___lU2pd {
  cursor: not-allowed !important;
}

.SectionHeader-module__absolute-centered___xmAGd {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SectionHeader-module__absolute___wcwoy {
  position: absolute;
}

.SectionHeader-module__relative___rrZJk {
  position: relative;
}

.SectionHeader-module__fixed___opGGS {
  position: fixed;
}

.SectionHeader-module__visible___O58lU {
  opacity: 1;
}

.SectionHeader-module__invisible___bfds1 {
  opacity: 0;
}

.SectionHeader-module__col-90___pdXgJ {
  width: 90% !important;
}

.SectionHeader-module__col-auto___FDUP1 {
  width: auto !important;
}

.SectionHeader-module__medical-tabs___FEGWr {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SectionHeader-module__medical-table-new___u1b4o {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SectionHeader-module__medical-table-new___u1b4o:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SectionHeader-module__medical-table-new___u1b4o::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SectionHeader-module__medical-table-new___u1b4o::-webkit-scrollbar-track {
  display: none;
}
.SectionHeader-module__medical-table-new___u1b4o.SectionHeader-module__no-pagination___GCP1_ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SectionHeader-module__medical-table-new___u1b4o.SectionHeader-module__no-pagination___GCP1_:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SectionHeader-module__medical-table-new___u1b4o.SectionHeader-module__no-pagination___GCP1_::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SectionHeader-module__medical-table-new___u1b4o.SectionHeader-module__no-pagination___GCP1_::-webkit-scrollbar-track {
  display: none;
}

.SectionHeader-module__medical-table-empty___Zbdez {
  padding: 14px 40px !important;
}

.SectionHeader-module__icon-btn___t3ZjQ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SectionHeader-module__search-icon___UJjHe {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SectionHeader-module__disable-select___NBfSH {
  user-select: none;
}

.SectionHeader-module__break-word___Roizd {
  word-break: break-word;
}

.SectionHeader-module__popup-clear-btn___QZlJz {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SectionHeader-module__scroll-m-b-20___Yvf3q {
  scroll-margin-bottom: 20px;
}

.SectionHeader-module__header___ZM0LC {
  color: #375844;
  padding: 15px 30px;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/SectionHeader/SectionHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  color: get-color(greenNew, dark);\n  padding: 15px 30px;\n  display: flex;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SectionHeader-module__font-s-10___kZE5m`,
	"fontS12": `SectionHeader-module__font-s-12___mLpif`,
	"fontS13": `SectionHeader-module__font-s-13___eIgak`,
	"fontS14": `SectionHeader-module__font-s-14___SExwR`,
	"fontS15": `SectionHeader-module__font-s-15___YU_Gq`,
	"fontS16": `SectionHeader-module__font-s-16___cCaVK`,
	"fontS18": `SectionHeader-module__font-s-18___hSOUE`,
	"fontS20": `SectionHeader-module__font-s-20___G72zv`,
	"fontS22": `SectionHeader-module__font-s-22___VbWuu`,
	"fontS28": `SectionHeader-module__font-s-28___np7uu`,
	"fontW400": `SectionHeader-module__font-w-400___yW0tZ`,
	"fontW500": `SectionHeader-module__font-w-500___XAfHb`,
	"fontW600": `SectionHeader-module__font-w-600___LvfiO`,
	"fontW700": `SectionHeader-module__font-w-700___Z9eSN`,
	"p5": `SectionHeader-module__p-5___lzOxM`,
	"p12": `SectionHeader-module__p-12___jkQOc`,
	"p16": `SectionHeader-module__p-16___mgRAR`,
	"p30": `SectionHeader-module__p-30___MyJKh`,
	"pB0": `SectionHeader-module__p-b-0___nSa5H`,
	"pB5": `SectionHeader-module__p-b-5___i66Vg`,
	"pB10": `SectionHeader-module__p-b-10___QNtID`,
	"pB12": `SectionHeader-module__p-b-12___HN3wu`,
	"pB16": `SectionHeader-module__p-b-16___v9nla`,
	"pB18": `SectionHeader-module__p-b-18___BF01l`,
	"pB20": `SectionHeader-module__p-b-20___JxSyq`,
	"pB25": `SectionHeader-module__p-b-25___dq4sk`,
	"pB30": `SectionHeader-module__p-b-30___JvDSM`,
	"pB50": `SectionHeader-module__p-b-50___AQ9F4`,
	"pT0": `SectionHeader-module__p-t-0___Bt1rd`,
	"pT12": `SectionHeader-module__p-t-12___MrQkk`,
	"pT16": `SectionHeader-module__p-t-16___bXUCd`,
	"pT18": `SectionHeader-module__p-t-18___WGm_a`,
	"pT20": `SectionHeader-module__p-t-20___mfjkH`,
	"pT30": `SectionHeader-module__p-t-30___jovxq`,
	"pT40": `SectionHeader-module__p-t-40___T5AEu`,
	"pT50": `SectionHeader-module__p-t-50___enws_`,
	"pL20": `SectionHeader-module__p-l-20___Gn_YJ`,
	"pL30": `SectionHeader-module__p-l-30___ZWSqr`,
	"pL40": `SectionHeader-module__p-l-40___BViSy`,
	"pR16": `SectionHeader-module__p-r-16___LytOW`,
	"pR20": `SectionHeader-module__p-r-20___ZDiHP`,
	"pR30": `SectionHeader-module__p-r-30___CsjS6`,
	"pR50": `SectionHeader-module__p-r-50___wZXSp`,
	"pR60": `SectionHeader-module__p-r-60___yJaQn`,
	"mB1": `SectionHeader-module__m-b-1___qpkNi`,
	"mB2": `SectionHeader-module__m-b-2___C5gi6`,
	"mB6": `SectionHeader-module__m-b-6___jUumo`,
	"mB8": `SectionHeader-module__m-b-8___SuMvE`,
	"mB10": `SectionHeader-module__m-b-10___n99JS`,
	"mB14": `SectionHeader-module__m-b-14___sN5Vc`,
	"mB16": `SectionHeader-module__m-b-16___OGouY`,
	"mB20": `SectionHeader-module__m-b-20___K1wKn`,
	"mB22": `SectionHeader-module__m-b-22___zQkjn`,
	"mB24": `SectionHeader-module__m-b-24___bWLHJ`,
	"mB30": `SectionHeader-module__m-b-30___Z3Txu`,
	"mB32": `SectionHeader-module__m-b-32___HXur9`,
	"mB40": `SectionHeader-module__m-b-40____BBu4`,
	"mT2": `SectionHeader-module__m-t-2___WKNf2`,
	"mT3": `SectionHeader-module__m-t-3___HhVzc`,
	"mT4": `SectionHeader-module__m-t-4___VTf_b`,
	"mT5": `SectionHeader-module__m-t-5___BjoF5`,
	"mT8": `SectionHeader-module__m-t-8___z6Ifu`,
	"mT10": `SectionHeader-module__m-t-10___Onnu_`,
	"mT15": `SectionHeader-module__m-t-15___dkHhZ`,
	"mT16": `SectionHeader-module__m-t-16___g7wCt`,
	"mT20": `SectionHeader-module__m-t-20___Dxsjp`,
	"mT22": `SectionHeader-module__m-t-22___XSF5h`,
	"mT30": `SectionHeader-module__m-t-30___BJVVN`,
	"mT32": `SectionHeader-module__m-t-32___HZ2kD`,
	"mLAuto": `SectionHeader-module__m-l-auto____J9iY`,
	"mL4": `SectionHeader-module__m-l-4___qZC2R`,
	"mL5": `SectionHeader-module__m-l-5___a4vWW`,
	"mL6": `SectionHeader-module__m-l-6___IMPI4`,
	"mL8": `SectionHeader-module__m-l-8___SoRu6`,
	"mL10": `SectionHeader-module__m-l-10___dmRmh`,
	"mL16": `SectionHeader-module__m-l-16___N56c8`,
	"mL20": `SectionHeader-module__m-l-20___wdYnB`,
	"mL24": `SectionHeader-module__m-l-24___Mohbp`,
	"mL30": `SectionHeader-module__m-l-30___PK_cR`,
	"mL35": `SectionHeader-module__m-l-35___opm4j`,
	"mL40": `SectionHeader-module__m-l-40___vx709`,
	"mR8": `SectionHeader-module__m-r-8___yYB4w`,
	"mR10": `SectionHeader-module__m-r-10___NVbBi`,
	"mR16": `SectionHeader-module__m-r-16___pL9X9`,
	"mR20": `SectionHeader-module__m-r-20___BbwWv`,
	"mR24": `SectionHeader-module__m-r-24___tPSsD`,
	"mR30": `SectionHeader-module__m-r-30___pdlZd`,
	"mR40": `SectionHeader-module__m-r-40___OrXWY`,
	"borderR3": `SectionHeader-module__border-r-3___dMglH`,
	"borderR4": `SectionHeader-module__border-r-4___botUG`,
	"borderR6": `SectionHeader-module__border-r-6___EbIyE`,
	"borderR10": `SectionHeader-module__border-r-10___cCYTu`,
	"borderR12": `SectionHeader-module__border-r-12___PXS8j`,
	"borderR16": `SectionHeader-module__border-r-16___mJFXw`,
	"borderR50": `SectionHeader-module__border-r-50___z3o1L`,
	"primaryBorder": `SectionHeader-module__primary-border___WRCUa`,
	"primaryBorderB": `SectionHeader-module__primary-border-b___KDeS_`,
	"primaryBorderT": `SectionHeader-module__primary-border-t___i2Ur0`,
	"primaryBorderL": `SectionHeader-module__primary-border-l___u4g_t`,
	"primaryBorderR": `SectionHeader-module__primary-border-r___mKjc1`,
	"secondaryBorder": `SectionHeader-module__secondary-border___rnNWO`,
	"secondaryBorderB": `SectionHeader-module__secondary-border-b___qPjp9`,
	"secondaryBorderT": `SectionHeader-module__secondary-border-t___h6NX9`,
	"secondaryBorderL": `SectionHeader-module__secondary-border-l___ytdpE`,
	"secondaryBorderR": `SectionHeader-module__secondary-border-r___qi3ay`,
	"gap0": `SectionHeader-module__gap-0___WD373`,
	"gap2": `SectionHeader-module__gap-2___DqxE2`,
	"gap4": `SectionHeader-module__gap-4___pclIg`,
	"gap5": `SectionHeader-module__gap-5___S70Ks`,
	"gap6": `SectionHeader-module__gap-6___lCPEr`,
	"gap8": `SectionHeader-module__gap-8___FPChN`,
	"gap10": `SectionHeader-module__gap-10___dU4Eo`,
	"gap12": `SectionHeader-module__gap-12___VFsPx`,
	"gap14": `SectionHeader-module__gap-14___G88vX`,
	"gap16": `SectionHeader-module__gap-16___X8K6t`,
	"gap18": `SectionHeader-module__gap-18___CbHhn`,
	"gap20": `SectionHeader-module__gap-20___u9GzI`,
	"gap24": `SectionHeader-module__gap-24___EkZ2e`,
	"gap26": `SectionHeader-module__gap-26___MBJTa`,
	"gap30": `SectionHeader-module__gap-30___CAbq6`,
	"gap32": `SectionHeader-module__gap-32___Qbpyc`,
	"gap40": `SectionHeader-module__gap-40___fvjzc`,
	"gap50": `SectionHeader-module__gap-50___sFbw0`,
	"flex1": `SectionHeader-module__flex-1___kvOhA`,
	"flexNone": `SectionHeader-module__flex-none___dUuds`,
	"flexColumn": `SectionHeader-module__flex-column___HSCnj`,
	"flexRow": `SectionHeader-module__flex-row___MlxKi`,
	"verticallyCentered": `SectionHeader-module__vertically-centered___StE7V`,
	"horizontallyCentered": `SectionHeader-module__horizontally-centered___cHnfN`,
	"horizontallyEnd": `SectionHeader-module__horizontally-end___nweBH`,
	"verticallyStart": `SectionHeader-module__vertically-start___mEi4e`,
	"spaceBetween": `SectionHeader-module__space-between___OUdGz`,
	"flexWrap": `SectionHeader-module__flex-wrap___ZbrvT`,
	"height100": `SectionHeader-module__height-100___NYRDc`,
	"width50": `SectionHeader-module__width-50___mhTky`,
	"width100": `SectionHeader-module__width-100___RyLT2`,
	"cursorPointer": `SectionHeader-module__cursor-pointer___pruaL`,
	"cursorNotAllowed": `SectionHeader-module__cursor-not-allowed___lU2pd`,
	"absoluteCentered": `SectionHeader-module__absolute-centered___xmAGd`,
	"absolute": `SectionHeader-module__absolute___wcwoy`,
	"relative": `SectionHeader-module__relative___rrZJk`,
	"fixed": `SectionHeader-module__fixed___opGGS`,
	"visible": `SectionHeader-module__visible___O58lU`,
	"invisible": `SectionHeader-module__invisible___bfds1`,
	"col90": `SectionHeader-module__col-90___pdXgJ`,
	"colAuto": `SectionHeader-module__col-auto___FDUP1`,
	"medicalTabs": `SectionHeader-module__medical-tabs___FEGWr`,
	"medicalTableNew": `SectionHeader-module__medical-table-new___u1b4o`,
	"noPagination": `SectionHeader-module__no-pagination___GCP1_`,
	"medicalTableEmpty": `SectionHeader-module__medical-table-empty___Zbdez`,
	"iconBtn": `SectionHeader-module__icon-btn___t3ZjQ`,
	"searchIcon": `SectionHeader-module__search-icon___UJjHe`,
	"disableSelect": `SectionHeader-module__disable-select___NBfSH`,
	"breakWord": `SectionHeader-module__break-word___Roizd`,
	"popupClearBtn": `SectionHeader-module__popup-clear-btn___QZlJz`,
	"scrollMB20": `SectionHeader-module__scroll-m-b-20___Yvf3q`,
	"header": `SectionHeader-module__header___ZM0LC`
};
module.exports = ___CSS_LOADER_EXPORT___;
